import qs from 'qs';
import { SearchModes } from '../constants';

const encodeSearchObjToQueryString = (currentFilterObject, searchMode, isDedicatedHotelPage) => {
  let searchInputObj = {
    ...currentFilterObject,
  };
  if (searchMode === SearchModes.CRUISE_TRIP) {
    const locationsValue = (currentFilterObject.locations || []).map(
      (location) => `${location.locationType},${location.value}`,
    );

    const cruiseShipsValue = (
      (currentFilterObject.filters && currentFilterObject.filters.cruiseShips) ||
      []
    ).map((cruiseShip) => `${cruiseShip.locationType},${cruiseShip.value}`);
    const cruiseLinesValue = (
      (currentFilterObject.filters && currentFilterObject.filters.cruiseLines) ||
      []
    ).map((cruiseLines) => cruiseLines.value);

    searchInputObj = {
      ...currentFilterObject,
      locations: locationsValue,
      filters: {
        ...(currentFilterObject.filters || {}),
        cruiseLines: cruiseLinesValue,
        cruiseShips: cruiseShipsValue,
      },
    };
  } else if (searchMode === SearchModes.HOTEL) {
    const hotelChains = currentFilterObject.filterHotelChains || [];
    const hotelNames = (currentFilterObject.filterHotelKeys || []).map((key) => ({
      value: btoa(key.value),
      label: key.label,
    }));

    searchInputObj = {
      ...currentFilterObject,
      hotelChains,
      hotelNames,
      sa: currentFilterObject.selectedAddress,
      hproviders:
        currentFilterObject.hotelProvidersToInclude &&
        currentFilterObject.hotelProvidersToInclude.length
          ? currentFilterObject.hotelProvidersToInclude
          : undefined,
    };
    delete searchInputObj.filterHotelChains;
    delete searchInputObj.filterHotelKeys;
    delete searchInputObj.selectedAddress;
    delete searchInputObj.doGetRemainingHotelsOnly;
    delete searchInputObj.doIgnoreStoredResults;
    delete searchInputObj.requestId;
    delete searchInputObj.hotelProvidersToInclude;
    if (isDedicatedHotelPage) {
      delete searchInputObj.sa;
      delete searchInputObj.searchMode;
    }
    delete searchInputObj.id;
    delete searchInputObj.name;
  }

  return qs.stringify(searchInputObj, { encodeValuesOnly: true });
};

export default encodeSearchObjToQueryString;
